<div *ngIf="cs.isBrowser" class="admin-modaldialog modal-basic">
  <div class="modal-content modal-theme2 modal-adjust">
    <div class="modal-header">
      <h4 class="modal-title">
        <ng-container *ngIf="subscriptionPlan?.type !== 'additional'">
          CHANGE SUBSCRIPTION DURATION
        </ng-container>
        <ng-container *ngIf="subscriptionPlan?.type === 'additional'">
          Additional Plan Confirmation
        </ng-container>
      </h4>
      <div class="cursor-pointer" (click)="closeModal()">
        <em class="icon-liteicon-close"></em>
      </div>
    </div>
    <div class="modal-body">
      <p *ngIf="subscriptionPlan?.type === 'upGrade' && planEndDate && futureExpireDate">
        You are about to change your current subscription duration before it
        ends on {{ planEndDate | date: 'longDate' }}. If you confirm, your plan
        will now end on {{ futureExpireDate | date: 'longDate' }}, and
        auto-renew for the same duration on that date. You can cancel auto-renew
        at anytime in Wallet > My Purchases > Subscription Plans.
      </p>
      <p *ngIf="subscriptionPlan?.type === 'downGrade' && planEndDate && futureExpireDate">
        You are about to plan your current subscription plan before it ends on
        {{ planEndDate | date: 'longDate' }}. If you confirm, your new
        downgraded plan will get activated after the end of the current
        subscription plan. Your new plan will end on
        {{ futureExpireDate | date: 'longDate' }}.
      </p>
      <ng-container *ngIf="subscriptionPlan?.type === 'additional'">
        <p class="mb-4">
          We noticed you currently have Active Subscription Plan(s) from
          <strong>{{ getPlanCreatorFullName() }}</strong>
          named
          <strong>{{ activeSubscriptionNames }}</strong>
          .
        </p>
        <p class="mb-4">
          Please note that you are allowed to purchase multiple different
          subscription plans from the same creator, as each plan may have
          different benefits, prices and expiration dates.
        </p>
        <p class="">
          You can review this information and make changes at anytime in Wallet
          > My Purchases > Subscription Plans.
        </p>
      </ng-container>
    </div>
    <div class="modal-footer">
      <button (click)="closeModal()" class="btn btn-default">Cancel</button>
      <button
        (click)="moveAhead()"
        class="btn btn-primary px-4 ml-4"
        type="button"
      >
        <ng-container *ngIf="subscriptionPlan?.type !== 'additional'">
          Confirm
        </ng-container>
        <ng-container *ngIf="subscriptionPlan?.type === 'additional'">
          Proceed
        </ng-container>
      </button>
    </div>
  </div>
</div>
